import React from 'react';
import { Route, Switch } from 'react-router-dom';
// import AuthenticatedRoute from '../components/authenticated-route';
// import UnauthenticatedRoute from '../components/unauthenticated-route';
import Loadable from 'react-loadable';
import SearchResult from '../components/search-result';
import ViewProperty from '../components/view-property';
import VisitProperty from '../components/visit-property';
import RentAgreement from '../components/rent-agreement';
import RentAgreementDetails from '../components/rent-agreement-details';
import Payment from '../components/payment';
import SocietyJoin from '../components/society-join';
import NotFound from './not-found';
import ScrollToTopRoute from '../components/scroll-to-top-route';
import AboutUs from './about-us';
import ContactUs from './contact-us';
import PrivacyPolicy from './privacy-policy';
import TermsOfUse from './terms-of-use';

const Homepage = Loadable({
  loader: () => import(/* webpackChunkName: "homepage" */ './homepage'),
  loading: () => null,
  modules: ['homepage']
});

// const Dashboard = Loadable({
//   loader: () => import(/* webpackChunkName: "dashboard" */ './dashboard'),
//   loading: () => null,
//   modules: ['dashboard']
// });

// const Login = Loadable({
//   loader: () => import(/* webpackChunkName: "login" */ './login'),
//   loading: () => null,
//   modules: ['login']
// });

// const Logout = Loadable({
//   loader: () => import(/* webpackChunkName: "logout" */ './logout'),
//   loading: () => null,
//   modules: ['logout']
// });


export default () => (
  <Switch>
    <ScrollToTopRoute exact path="/" component={Homepage} />
    <ScrollToTopRoute exact path="//" component={Homepage} />


    {/* <AuthenticatedRoute exact path="/dashboard" component={Dashboard} /> */}
    {/* <UnauthenticatedRoute exact path="/login" component={Login} /> */}
    {/* <AuthenticatedRoute exact path="/logout" component={Logout} /> */}
    <ScrollToTopRoute exact path="/search/:propertytype" component={SearchResult} />
    <ScrollToTopRoute exact path="/viewproperty/:id" component={ViewProperty} />
    <ScrollToTopRoute exact path="/visitproperty/:id" component={VisitProperty} />
    <ScrollToTopRoute exact path="/payment/:status" component={Payment} />
    <ScrollToTopRoute exact path="/rentagreement/details/:id" component={RentAgreementDetails} />
    <ScrollToTopRoute exact path="/rentagreement/:id?" component={RentAgreement} />
    <ScrollToTopRoute exact path="/societyjoin" component={SocietyJoin} />
    <ScrollToTopRoute exact path="/aboutus" component={AboutUs} />
    <ScrollToTopRoute exact path="/contactus" component={ContactUs} />
    <ScrollToTopRoute exact path="/privacypolicy" component={PrivacyPolicy} />
    <ScrollToTopRoute exact path="/termsofuse" component={TermsOfUse} />
    <ScrollToTopRoute component={NotFound} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/app/routes/index.js